import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { fetchApi } from '../../Services/NetworkServcice';
import ChooseCategory from './ChooseCategory';
import PreviewBakery from '../PreviewBakery';
import BakeryPrice from './SetPrice';
import Products from './Options';

class Bakery extends React.Component {
    constructor(props) {
        super();

        this.state = {
            // State
            options: [],
            step: 0,

            duration: 5,

            // Crea
            _id: null,
            filename: '',
            category: '',
            price: '',
            priceUnit: 'piece',
            pieceNb: '1',
            calories: '',
            subtitle: '',
            weight: '',
            weightUnit: 'g',
            promotion: false,
            expirationDate: null,
            startDate: null,
            containsArachide: false,
            containsLactose: false,
            containsNuts: false,
            containsSesame: false,
            containsEggs: false,
            containsGluten: false,
            containsSoja: false,
            withoutGluten: false,
            madeHere: false,
            isFrozen: false,
            bio: false,
            labelrouge: false,
            templateName: props.templateName
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveCrea = this.handleSaveCrea.bind(this);
        this.setSlide = this.setSlide.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentDidMount() {
        fetchApi('/sequences/bakery')
            .then((res) => res.json())
            .then((bakery) => {
                const options = {};
                bakery.forEach((entry) => {
                    if (!options[entry.category]) {
                        options[entry.category] = [];
                    }

                    options[entry.category].push(entry.filename);
                });

                this.setState({ options });
            });
    }

    reset() {
        this.setState({
            _id: null,
            filename: '',
            category: '',
            price: '',
            priceUnit: 'piece',
            pieceNb: '1',
            calories: '',
            subtitle: '',
            weight: '',
            weightUnit: 'g',
            promotion: false,
            expirationDate: null,
            startDate: null,
            containsArachide: false,
            containsLactose: false,
            containsNuts: false,
            containsSesame: false,
            containsEggs: false,
            containsGluten: false,
            withoutGluten: false,
            madeHere: false,
            isFrozen: false,
            bio: false,
            labelrouge: false,
            templateName: this.props.templateName,
            duration: 5,

            step: 0
        });
    }

    handleClose() {
        this.reset();
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSaveCrea() {
        const crea = {
            _id: this.state._id,
            filename: this.state.filename,
            category: this.state.category,
            price: this.state.price.replace(',', '.'),
            priceUnit: this.state.priceUnit,
            pieceNb: this.state.pieceNb,
            calories: this.state.calories,
            subtitle: this.state.subtitle,
            weight: this.state.weight,
            weightUnit: this.state.weightUnit,
            promotion: this.state.promotion,
            expirationDate: this.state.expirationDate,
            startDate: this.state.startDate,
            containsArachide: this.state.containsArachide,
            containsLactose: this.state.containsLactose,
            containsNuts: this.state.containsNuts,
            containsSesame: this.state.containsSesame,
            containsEggs: this.state.containsEggs,
            containsGluten: this.state.containsGluten,
            containsSoja: this.state.containsSoja,
            withoutGluten: this.state.withoutGluten,
            madeHere: this.state.madeHere,
            isFrozen: this.state.isFrozen,
            bio: this.state.bio,
            labelrouge: this.state.labelrouge,
            templateName: this.state.templateName
        };

        this.props.handleSaveCrea({
            creative: crea,
            creaType: 'Bakery',
            expirationDate: this.state.expirationDate,
            startDate: this.state.startDate,
            duration: this.state.duration
        });

        this.handleClose();
    }

    setSlide(s, duration) {
        this.setState({ ...s, price: s.price.toString().replace('.', ','), step: 1, duration });
    }

    render() {
        let component = null;

        switch (this.state.step) {
            case 0:
                component = (
                    <ChooseCategory
                        filename={this.state.filename}
                        subtitle={this.state.subtitle}
                        options={this.state.options}
                        handleSelectOption={(e) =>
                            this.setState({
                                category: e,
                                filename: this.state.options[e][0]
                            })
                        }
                        handleSetSub={(v) => this.setState({ subtitle: v })}
                        handleSwitchOption={(index, option) =>
                            this.setState({
                                filename: this.state.options[option][
                                    index < 0
                                        ? 0
                                        : index >= this.state.options[option].length
                                        ? this.state.options[option].length - 1
                                        : index
                                ]
                            })
                        }
                    />
                );
                break;
            case 1:
                component = (
                    <BakeryPrice
                        price={this.state.price}
                        priceUnit={this.state.priceUnit}
                        pieceNb={this.state.pieceNb}
                        weight={this.state.weight}
                        weightUnit={this.state.weightUnit}
                        calories={this.state.calories}
                        promotion={this.state.promotion}
                        expirationDate={this.state.expirationDate}
                        startDate={this.state.startDate}
                        handleChange={this.handleChange}
                        allowSlidesDurationChange={this.props.allowSlidesDurationChange}
                        maxDuration={this.props.maxDuration}
                        onChangeDuration={(e) => this.setState({ duration: parseInt(e.target.value) })}
                        duration={this.state.duration}
                    />
                );
                break;
            case 2:
                component = (
                    <Products
                        setBoolean={(name, value) => this.setState({ [name]: value })}
                        containsArachide={this.state.containsArachide}
                        containsLactose={this.state.containsLactose}
                        containsNuts={this.state.containsNuts}
                        containsSesame={this.state.containsSesame}
                        madeHere={this.state.madeHere}
                        containsEggs={this.state.containsEggs}
                        containsGluten={this.state.containsGluten}
                        isFrozen={this.state.isFrozen}
                        bio={this.state.bio}
                        labelrouge={this.state.labelrouge}
                    />
                );
                break;
            default:
                break;
        }

        return (
            <div>
                <header>
                    <div className="progress-assistant">
                        <div className={`item${this.state.step >= 0 ? ' active' : ''}`}>
                            <div
                                className="round"
                                onClick={() => this.setState({ step: Math.min(0, this.state.step) })}
                            >
                                1
                            </div>
                            {this.state.step !== 0 || <span>Choisissez un produit</span>}
                        </div>
                        <div className={`item${this.state.step >= 1 ? ' active' : ''}`}>
                            <div
                                className="round"
                                onClick={() => this.setState({ step: Math.min(1, this.state.step) })}
                            >
                                2
                            </div>
                            {this.state.step !== 1 || <span>Renseignez plus d’informations</span>}
                        </div>
                        <div className={`item${this.state.step >= 2 ? ' active' : ''}`}>
                            <div
                                className="round"
                                onClick={() => this.setState({ step: Math.min(2, this.state.step) })}
                            >
                                3
                            </div>
                            {this.state.step !== 2 || <span>Prix et programmation</span>}
                        </div>
                    </div>
                    <div className="buttons">
                        {this.state.step <= 0 || (
                            <button
                                className="prev"
                                onClick={() => this.setState((prevState) => ({ step: prevState.step - 1 }))}
                            >
                                Retour
                            </button>
                        )}
                        <button
                            className="button-assistant"
                            disabled={
                                (this.state.step === 1 && this.state.price.trim().length === 0) ||
                                (this.state.step === 0 && this.state.category.length === 0)
                            }
                            onClick={() => {
                                if (this.state.step < 2) {
                                    return this.setState((prevState) => ({ step: prevState.step + 1 }));
                                }

                                this.handleSaveCrea();
                            }}
                        >
                            {this.state.step < 2 ? 'Suivant' : 'Enregistrer'}
                        </button>
                    </div>
                </header>
                <div>
                    <Row>
                        <Col md={9}>{component}</Col>
                        <Col md={3}>
                            <p className="center">Prévisualisation</p>
                            <PreviewBakery {...this.state} orientation={this.props.orientation} />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Bakery;
